import React from 'react';

export type DownloadState = 'idle' | 'downloading' | 'success' | 'error';

export interface DownloadIconProps {
  state: DownloadState;
  error?: string | null;
  className?: string;
}

export const DownloadIcon: React.FC<DownloadIconProps> = ({ state, error, className = "w-4 h-4" }) => {
  switch (state) {
    case 'downloading':
      return <div className={`border-2 border-gray-300 border-t-blue-600 rounded-full animate-spin ${className}`}></div>;
    
    case 'success':
      return (
        <svg className={`text-green-600 ${className}`} viewBox="0 0 24 24" fill="none">
          <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    
    case 'error':
      return (
        <svg className={`text-red-500 ${className}`} viewBox="0 0 24 24" fill="none">
          <path d="M12 9v3m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    
    case 'idle':
    default:
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path d="M12 16L12 8M9 13L12 16L15 13M6 21H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
  }
};

export const getDownloadTooltip = (state: DownloadState, error?: string | null): string => {
  switch (state) {
    case 'downloading':
      return 'Downloading audio...';
    case 'success':
      return 'Download completed!';
    case 'error':
      return error || 'Download failed';
    case 'idle':
    default:
      return 'Download audio';
  }
};

export const getDownloadButtonClassName = (state: DownloadState): string => {
  switch (state) {
    case 'success':
      return 'bg-green-50 border-green-200';
    case 'error':
      return 'bg-red-50 border-red-200 hover:bg-red-100';
    default:
      return '';
  }
};

export const isDownloadDisabled = (state: DownloadState): boolean => {
  return state === 'downloading' || state === 'success';
}; 